import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
} from "@angular/core";

@Component({
  selector: "evrideo-calendar-expandable-red-line-indicator",
  templateUrl: "./calendar-expandable-red-line-indicator.component.html",
  styleUrls: ["./calendar-expandable-red-line-indicator.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarExpandableRedLineIndicatorComponent implements OnInit {
  @Input() redLineVisible;

  constructor() {}

  ngOnInit(): void {}
}
